<template>
	<div style="height: 100%;">
  	<router-view></router-view>
	</div>
</template>

<script>

import List from './cloudrec/List'
import Editor from './cloudrec/Editor'
import CreateClip from './cloudrec/CreateClip'
import VideoEditor from './cloudrec/VideoEditor'

export default {
	routes: [
		{
			path: "",
			redirect: "/cloudrec/list"
		},
		{
			path: "list",
			components: {
				sidebar: List
			},
			meta: {showNavigationDrawer: true, search: false},
			name: "CloudRec list"
		},
		{
			path: "clip",
			component: CreateClip,
			name: "CloudRec create clip"
		},
		{
			path: "video-editor/:event_uuid?",
			components: {
				default: VideoEditor,
				sidebar: List
			},
			props: {
				default: true,
				sidebar: false
			},
			name: "CloudRec video editor"
		},
		{
			path: "event/:uuid",
			name: "CloudRec event",
			meta: {search: false},
			components: {
		  		default: Editor,
		  		sidebar: List
		  	},
		  	props: {
		  		default: true,
		  		sidebar: false
		  	}
		}
	]
}
</script>